import styled from 'styled-components'
import { Popup, Dropdown } from 'semantic-ui-react'

export const WinnerPopup = styled(Popup)`
    &.ui.popup {
        border-color: ${({ $borderColor }) => $borderColor};
        text-align: center;
        font-size: 18px;
        padding: .5em;
        &:before {
            box-shadow: 1px 1px 0 0 ${({ $borderColor }) => $borderColor};
        }
        &.bottom:before {
            box-shadow: -1px -1px 0 0 ${({ $borderColor }) => $borderColor};
        }
        &>div {
            margin: .5em 0;
        }
        &>.spec {
            font-size: 16px;
        }
        &>.vuz {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.5);
        }
        &>.reward {
            margin-bottom: .3em;
            &>i.icon {
                color: ${({ $rewardColor }) => $rewardColor};
                padding: 5px 0!important;
                font-size: 14px;
                box-shadow: 0 0 0 0.1em ${({ $rewardColor }) => $rewardColor} inset;
                &:before {
                    font-size: 16px;
                }
            }
        }
    }
`

export const WinnersContainer = styled.div`
    margin-top: 1em;

    &>svg>g {
        &>circle {
            stroke-width: 1;
            cursor: pointer;
        }
        &>circle:hover {
            transform: scale(1.1);
            transform-box: fill-box;
            transform-origin: center;
        }
    }
`

export const ControlButtons = styled.div`
    text-align: center;
    &>.icon{
        cursor: pointer;
        &:not(:hover) {
            color: rgba(0, 0, 0, .50);
        } 
    }
`

export const WinnersDropdown = styled(Dropdown)`
    float: right;

    &.ui.selection.dropdown,
    &.ui.selection.active.dropdown,
    &.ui.selection.active.dropdown .menu {
        border-color: #f67e04;
        .dropdown.icon {
            margin: auto;
        }
        .menu.transition>.item {
            padding: .5em .636em;
            min-height: auto;
        }
    }

    @media (max-width: 767px) {
        &&&& {
            float: initial;
            display: grid;
            margin-top: 1em;
            min-width: auto;
        }
    }
`
export const WinnersHeader = styled.div`
    margin: 0 1em 1em;
`